export default "__VITE_ASSET__5162qPxa__"